import Form from 'react-bootstrap/Form';
import styled from '@emotion/styled';

export const FormGroup = styled(Form.Group)`
	width: 100%;
`;
